import React from "react";
import { Chip, ChipProps } from "@shared/src/components/ui/chip";
import { useP2PConfig } from "@shared/src/hooks/useP2PConfig";
import { useHostStore } from "@shared/src/stores/useHostStore";

export interface NetworkChipProps extends Omit<ChipProps, "children"> {
  showDropdownIcon?: boolean;
  networkId?: number;
}

export function NetworkChip({ showDropdownIcon = false, networkId, className, ...props }: NetworkChipProps) {
  const sdk = useHostStore(state => state.sdk);
  const networks = sdk?.config.networks;
  const networkDetails = networks?.find(network => networkId === network.id);

  return (
    <Chip icon={networkDetails?.iconUrl} className={className} {...props}>
      <span className="truncate">{networkDetails?.name}</span>
      {showDropdownIcon && (
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" className="ml-1 shrink-0">
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </Chip>
  );
}
